import { Divider, Modal, ModalClose, ModalDialog, Typography } from '@healthinal/ui';
import {
  CreateQuantiferonTestDto,
  CreateSputumTestDto,
  CreateTspotTestDto,
  CreateTuberculinTestDto,
  CreateXrayTestDto,
  LabOrderDto,
  LabOrderDtoType,
} from '../../../api/generated/model';
import { transformLabOrderToCreateTestDto } from '../../../utils/labOrder.ts';
import { CreateQuantiferonResultForm } from './CreateQuantiferonResultForm.tsx';
import { CreateSputumResultForm } from './CreateSputumResultForm.tsx';
import { CreateTspotResultForm } from './CreateTspotResultForm.tsx';
import { CreateTuberculinResultForm } from './CreateTuberculinResultForm.tsx';
import { CreateXrayResultForm } from './CreateXrayResultForm.tsx';

export function EditLabOrderResultDialog({
  open,
  onClose,
  order,
}: {
  open: boolean;
  onClose: () => void;
  order: LabOrderDto;
}) {
  const testDto = transformLabOrderToCreateTestDto(order);
  // debugger;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ width: 730, overflowY: 'scroll' }}>
        <ModalClose />
        <Typography level={'h3'}>Testresultat bearbeiten</Typography>
        <Divider />
        {order.type === LabOrderDtoType.TUBERCULIN && (
          <CreateTuberculinResultForm
            patientId={order.patient.id}
            onClose={onClose}
            currentResult={testDto as CreateTuberculinTestDto}
            currentResultId={order.id}
          />
        )}
        {order.type === LabOrderDtoType.XRAY && (
          <CreateXrayResultForm
            patientId={order.patient.id}
            onClose={onClose}
            currentResult={testDto as CreateXrayTestDto}
            currentResultId={order.id}
          />
        )}
        {order.type === LabOrderDtoType.SPUTUM && (
          <CreateSputumResultForm
            patientId={order.patient.id}
            onClose={onClose}
            currentResult={testDto as CreateSputumTestDto}
            currentResultId={order.id}
          />
        )}
        {order.type === LabOrderDtoType.BLOOD_TSPOT && (
          <CreateTspotResultForm
            patientId={order.patient.id}
            onClose={onClose}
            currentResult={testDto as CreateTspotTestDto}
            currentResultId={order.id}
          />
        )}
        {order.type === LabOrderDtoType.BLOOD_QUANTIFERON && (
          <CreateQuantiferonResultForm
            patientId={order.patient.id}
            onClose={onClose}
            currentResult={testDto as CreateQuantiferonTestDto}
            currentResultId={order.id}
          />
        )}
      </ModalDialog>
    </Modal>
  );
}
